import { FormFormat, TemplateCategory } from '@heidi/schema/ml-scribe';

/**
 * A JSON form template: a form-category template whose `form_format` is
 * `json`.
 *
 * Not flag-gated. Fill and download of a template that already exists stay
 * available when `release-growth-enable-json-form` is off; the flag only
 * hides upload, creation, field edits and community publish.
 *
 * `form_format` is `string`, matching `isXmlFormTemplate`, so a gallery
 * template (a different generated enum for the same values) can use it too.
 */
export const isJsonFormTemplate = (
  template:
    | {
        template_category?: string | null;
        form_format?: string | null;
      }
    | null
    | undefined
): boolean =>
  template?.template_category === TemplateCategory.FORM_TEMPLATE &&
  template.form_format === FormFormat.json;

/**
 * True when the JSON form rollout keeps this template off Community (flag off
 * and the template is JSON), independent of `is_publishable`. Every surface
 * that offers Community publishing reads this one rule.
 */
export const isJsonFormCommunityBlocked = (
  template: Parameters<typeof isJsonFormTemplate>[0],
  isJsonFormEnabled: boolean
): boolean => !isJsonFormEnabled && isJsonFormTemplate(template);
